import React, { useEffect, useState } from 'react'
import Dialog from '../../../../../dialog/Dialog'
import { Alert } from '@mui/material'
import ChipMedia from '../../../../../chip/ChipMedia'
import { handlerErrorV2 } from '../../../../../../utils/errors'
import { getEvidenceOfLearningByLcIdAndLevelId } from '../../../../../../services/maestro/evidence-of-learning.service'
import Loading from '../../../../../Loading/Loading'
import { useByStudent } from '../ByStudentContext/ByStudentContext'
import ReadOnlyTextEditor from '../../../../../TextEditor/ReadOnlyTextEditor'
import { getNoteByLcIdAndLevelIdAndGsId } from '../../../../../../services/maestro/note.service'

const DialogEvidenceOfLearning = ({ onClose, open, formData, type = 'evidence-of-learning' }) => {
  const { studentSelected, curriculumId } = useByStudent()
  const [form, setForm] = useState(formData)
  const [errors, setError] = useState(null)
  const [isLoading, setIsLoading] = useState(true)

  const onLoad = async () => {
    setIsLoading(true)
    try {
      let response = {
        error: {
          message: 'Type invalid'
        }
      }
      if (type === 'evidence-of-learning') {
        response = await getEvidenceOfLearningByLcIdAndLevelId(
          curriculumId,
          studentSelected?._id,
          formData.lcId,
          formData.levelId
        )
      }
      if (type === 'note') {
        response = await getNoteByLcIdAndLevelIdAndGsId(
          curriculumId,
          studentSelected?._id,
          formData.lcId,
          formData.levelId,
          formData.gsId,
          'main'
        )
      }
      if (!response.data && response.error) {
        setForm({ ...formData, comment: '' })
      } else {
        setForm(response.data)
      }
    } catch (error) {
      const message = handlerErrorV2(error)
      setError({ error: true, message })
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (open) {
      onLoad()
    }
  }, [open])

  return (
    <>
      <Dialog
        id='evidence-of-learning'
        show={open}
        title={type === 'note' ? 'Note' : type.replace(/-/g, ' ')}
        onCloseHeader={true}
        maxWidth={'md'}
        onClose={onClose}
      >
        {isLoading ? (
          <>
            <div className='h-screen-1/2'>
              <Loading />
            </div>
          </>
        ) : (
          <div className='flex flex-col gap-2'>
            <ReadOnlyTextEditor
              content={form.comment}
              placeholder='The student has not entered any information yet'
            />
            {form.media && form.media.length > 0 && (
              <div className='flex flex-wrap gap-4 items-center'>
                {form.media.map((data, index) => {
                  return (
                    <ChipMedia key={`media-${index}-${data._id}-${data.type}`} index={index} data={data} />
                  )
                })}
              </div>
            )}
            {errors && errors.message && (
              <Alert severity='error' onClose={() => setInputErrors({ message: null })}>
                {errors.message}
              </Alert>
            )}
          </div>
        )}
      </Dialog>
    </>
  )
}

export default DialogEvidenceOfLearning
